import React from 'react';
import { FormField, FormError, Label } from '@redpanda/ui';

interface FormFieldWithErrorProps {
  label: string;
  required?: boolean;
  error?: string;
  helpText?: string;
  children: React.ReactNode;
  htmlFor?: string;
}

const FormFieldWithError: React.FC<FormFieldWithErrorProps> = ({
  label,
  required = false,
  error,
  helpText,
  children,
  htmlFor
}) => {
  return (
    <FormField>
      <Label htmlFor={htmlFor}>
        {label}
        {required && <span className="ml-1">*</span>}
      </Label>
      {children}
      {error && <FormError>{error}</FormError>}
      {helpText && !error && (
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {helpText}
        </p>
      )}
    </FormField>
  );
};

export default FormFieldWithError;